import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MensagensService } from 'max-ng-lib';

import { ConfiguracaoWhatsappTemplate } from './../content/pages/components/models/ferramentas/configuracao-whatsapp.model';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';

@Injectable({
	providedIn: "root",
})
export class TipoTemplateWhatsappService extends GenericServicesMotoristaService {
	constructor(
		private _mensagensService: MensagensService,
		private _httpClient: HttpClient
	) {
		super();
	}
	getMensagensService(): MensagensService {
		return this._mensagensService;
	  }

	  getHttpClient(): HttpClient {
		return this._httpClient;
	  }

	  getUrlRecurso(): string {
		return '/tipoTemplateWhatsapp';
	  }

	  listarTodosTiposTemplateWhatsapp() {

		return this.get<ConfiguracaoWhatsappTemplate[]>('/listar', {exibirLoading: false});
	  }
}
